const mutations = {
    SET_ERROR_MERCHANTS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
